<div class="flex flex-col">
  <div class="bg-gray-100 text-gray-800 py-4 px-6 rounded-t-lg">
    <h2 class="text-xl font-bold mb-0">Undertakings of the Partner</h2>
  </div>
  <div
    class="relative w-full mx-4 sm:mx-0 bg-white rounded-lg shadow-lg overflow-y-auto p-6"
  >
    <!-- Header -->

    <!-- Body -->
    <div class="p-0 space-y-6 text-gray-700">
      <p>
        In the context of the call for ideas
        <strong>“Super Sapiens Europe”</strong>, Scientifica S.p.A. (the
        <strong>Disclosing Party</strong>) grants the Partner (the
        <strong>Receiving Party</strong>) access to a platform containing
        <strong>Confidential Information</strong> related to start-ups and their
        projects submitted for evaluation. This disclosure is subject to the
        terms and conditions outlined in the agreement previously signed between
        the parties, including confidentiality and data protection provisions.
      </p>

      <!-- Section 1 -->
      <div>
        <h3 class="text-lg font-semibold text-gray-900 mb-2">
          1. Definition of Confidential Information
        </h3>
        <ul class="list-disc ml-6 space-y-2">
          <li>
            Scientific or technical information, inventions, designs, processes,
            formulas, improvements, technologies, or methods.
          </li>
          <li>
            Concepts, reports, data, know-how, works-in-progress, designs,
            drawings, specifications, software, source code, and databases.
          </li>
          <li>
            Marketing strategies, financial information, projections, business
            plans, and performance results.
          </li>
          <li>
            Trade secrets, plans for products/services, and customer or supplier
            information.
          </li>
        </ul>
      </div>

      <!-- Section 2 -->
      <div>
        <h3 class="text-lg font-semibold text-gray-900 mb-2">
          2. Obligations of the Receiving Party
        </h3>
        <ul class="list-disc ml-6 space-y-2">
          <li>
            Confirms acknowledgment and acceptance of these terms and the signed
            agreement.
          </li>
          <li>
            Commits to keeping the Confidential Information strictly
            confidential.
          </li>
          <li>
            Agrees not to use the information for purposes outside the
            evaluation process.
          </li>
          <li>
            Ensures compliance by individuals to whom the information is
            disclosed.
          </li>
        </ul>
      </div>

      <!-- Section 3 -->
      <div>
        <h3 class="text-lg font-semibold text-gray-900 mb-2">
          3. Return or Destruction of Confidential Information
        </h3>
        <p>
          Upon completion of the evaluation process or upon request by the
          Disclosing Party, the Receiving Party agrees to promptly return or
          permanently delete all copies of the Confidential Information.
        </p>
      </div>

      <!-- Section 4 -->
      <div>
        <h3 class="text-lg font-semibold text-gray-900 mb-2">
          4. Breach of Confidentiality
        </h3>
        <p>
          The Receiving Party shall immediately notify the Disclosing Party of
          any unauthorized use or breach of confidentiality and acknowledges
          that such a breach may cause irreparable harm.
        </p>
      </div>

      <!-- Section 5 -->
      <div>
        <h3 class="text-lg font-semibold text-gray-900 mb-2">
          5. Acknowledgment and Acceptance
        </h3>
        <p>
          By accessing the platform, the Receiving Party confirms acceptance of
          these terms and acknowledges potential legal actions for
          non-compliance.
        </p>
      </div>

      <!-- Section 6 -->
      <div>
        <h3 class="text-lg font-semibold text-gray-900 mb-2">
          6. Limitation of Liability
        </h3>
        <p>
          The Receiving Party agrees to indemnify and hold harmless Scientifica
          S.p.A. from any liability arising from failure to adhere to these
          obligations.
        </p>
      </div>

      <!-- Section 7 -->
      <div>
        <h3 class="text-lg font-semibold text-gray-900 mb-2">
          7. Governing Law and Jurisdiction
        </h3>
        <p>
          This acknowledgment shall be governed by the laws specified in the
          original agreement, and any disputes shall be resolved in the
          designated courts.
        </p>
      </div>
    </div>
    <div class="flex justify-end space-x-4 mt-8">
      <button mat-button color="warn" (click)="onDecline()">Cancel</button>
      <button mat-raised-button class="bg-purple-800 text-purple-50" (click)="onAccept()">
        Accept
      </button>
    </div>
  </div>
</div>
